export function getFactoryFor(classType: Function): ng.IDirectiveFactory {
    const factory = (...args): Function => {
        var directive = classType as any;
        return new (directive.bind(directive, ...args));
    };
    factory.$inject = classType.$inject;
    return factory as any;
}